import { Box, Container, Typography, Stack } from '@mui/material';
import { HeroSection } from '../../components/marketing/HeroSection';

export const SchedulePage = () => {
  return (
    <Box>
      <HeroSection
        title="Thank you!"
        subtitle="Set up a call with someone on our team. Anyone on our team can answer your questions and tell you about our service."
        variant="gradient"
      />

      <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 } }}>
        <Stack spacing={4}>
          <Box
            sx={{
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 1,
              overflow: 'hidden',
            }}
          >
            <Typography
              variant="h6"
              fontWeight={600}
              sx={{ p: 2, bgcolor: 'grey.100', borderBottom: '1px solid', borderColor: 'divider' }}
            >
              Schedule with Ted
            </Typography>
            <Box sx={{ width: '100%', height: 600 }}>
              <iframe
                src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ2Hncvycpv7wSLgCLiUMv1GTEoDY3uNtd1jFq05S9E2wbszDvcCcGwJwo0Bb-EAhApC6dDheWSD?gv=true"
                style={{ border: 0, width: '100%', height: '100%' }}
                title="Schedule with Ted"
              />
            </Box>
          </Box>

          <Box
            sx={{
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 1,
              overflow: 'hidden',
            }}
          >
            <Typography
              variant="h6"
              fontWeight={600}
              sx={{ p: 2, bgcolor: 'grey.100', borderBottom: '1px solid', borderColor: 'divider' }}
            >
              Schedule with Erin
            </Typography>
            <Box sx={{ width: '100%', height: 600 }}>
              <iframe
                src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3mR6P4bLoRiq3DLsbHoceugM5ZT8rFADKeYfvQxU21dSiAm3mJs6SLq7ucYNxgOCa3pua_NQsm?gv=true"
                style={{ border: 0, width: '100%', height: '100%' }}
                title="Schedule with Erin"
              />
            </Box>
          </Box>
        </Stack>

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Prefer email?{' '}
            <Typography
              component="a"
              href="mailto:contact@fancyhands.com"
              sx={{ color: 'primary.main', textDecoration: 'none' }}
            >
              contact@fancyhands.com
            </Typography>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
